import axios from 'axios'
import * as ksoAccount from '@account/kso-acct-sdk'

const isEnvDevelopment = process.env.NODE_ENV === 'development'
axios.defaults.withCredentials = true
axios.defaults.baseURL = isEnvDevelopment ? '/' : 'https://api-kos.wps.cn'
const service = axios.create({
  timeout: 5 * 60 * 1000
})

service.interceptors.request.use(async (config) => {
  try {
    let popToken = await ksoAccount.signPopToken(config.method, config.url)
    if (popToken !== undefined && popToken !== 'empty') {
      config.headers['X-Pop-Token'] = popToken;
    }
  } catch (error) {
    console.error(error)
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

service.interceptors.response.use(async (result) => {
  const { data } = result || {}
  return data
}, (error) => {
  const status = error?.response?.status
  if (status) {
    return Promise.reject(error?.response?.data)
  }
  return Promise.reject(error)
})

export default service
